import * as Yup from "yup";

export const WithLogInForm = Yup.object({
  year: Yup.number().typeError("Year specify a number").required("Year is required"),
  type: Yup.string(),
  model: Yup.string().required("Model is required"),
  serialNumber: Yup.string().required("Serial Number is required"),
  manufacturers: Yup.string(),
  machineHours: Yup.string().required("SMU is required"),
  smu: Yup.string().required("Machine Hours is required"),
  description: Yup.string().required("description is required"),
  images: Yup.array().min(1, "At least one image must be uploaded").required("Please upload at least one image"),
  status: Yup.string().required("Status is required"),
  price: Yup.number().typeError("Year specify a number").required("Price is required"),
  currency: Yup.string().required("Currency is required"),
  sortOrder: Yup.string(),
  // location: Yup.string().required("Location is required"),
});

export const WithoutLogInForm = Yup.object({
  year: Yup.number().typeError("Year specify a number").required("Year is required"),
  type: Yup.string().required("Category is required"),
  model: Yup.string().required("Model is required"),
  serialNumber: Yup.string().required("Serial Number is required"),
  manufacturers: Yup.string().required("Manufacturer is required"),
  machineHours: Yup.string().required("SMU is required"),
  smu: Yup.string().required("Machine Hours is required"),
  description: Yup.string().required("description is required"),
  images: Yup.array().min(1, "At least one image must be uploaded").required("Please upload at least one image"),
  status: Yup.string().required("Status is required"),
  price: Yup.number().typeError("Year specify a number").required("Price is required"),
  currency: Yup.string().required("Currency is required"),
  sortOrder: Yup.string(),
  // location: Yup.string().required("Location is required"),
});
